import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AdminNavBar from "../../NavBar/AdminNavBar";
import style from './userFullView.module.css'
import formattedDateTime from "../../../../utils/formatDatewithTime"
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function UserFullView() {

    const { employeeId } = useParams();
    const [users, setUsers] = useState({});
    const [payrolls, setPayrolls] = useState('');
    const [error, setError] = useState("");
    const apiUrl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    const fetchPayrollById = () => {
        return (
            fetch(`${apiUrl}/payroll/${employeeId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
            })
                .then((res) => res.json())
                .then((data) => setPayrolls(data.payroll))
                .catch((err) => setError(err.message))
        )
    }

    const fetchUsersById = () => {
        return (
            fetch(`${apiUrl}/employee-dashboard/${employeeId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            })
                .then((res) => res.json())
                .then((data) => setUsers(data.user))
                .catch((err) => setError(err.message))
        )
    }

    useEffect(() => {
        fetchPayrollById();
        fetchUsersById()
    });


    if (error) return <p className="text-danger">{error}</p>;

    return (
        <>
            <div className="container  mb-5">
                <AdminNavBar />
                <div className="row pt-lg-2 pb-3 pb-lg-3">

                    {/* Error Component */}
                    {error && <p className="text-danger text-center">{error}</p>}

                    <div className="row mt-lg-2 mb-0 ">
                        {/* BreadCrumb Linkss */}
                        <div className="col-8 col-lg-5 ">
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}`}
                                name="Dashboard"
                                icon={true}
                            />
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}/all-users`}
                                name="All Users"
                                icon={true}
                            />
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}/users/${employeeId}`}
                                name={`Full info about ${employeeId}`}
                            />
                        </div>
                    </div>
                </div>
                <div className={style.fullViewContainer}>

                    <table className="table table-striped table-hover">

                        <tbody>
                            <tr>
                                <td className={`${style.text} ps-4 w-50`}>Name</td>
                                <td className={`${style.text} ps-4 w-50`}>
                                    {users?.firstName ? users.firstName : "Pending"} {users?.lastName ? users.lastName : ""}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Employee ID</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.employeeId ? users.employeeId : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Email</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.email ? users.email : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Phone</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.phonePrimary ? users.phonePrimary : "Pending"}
                                    {users?.phoneSecondary ? users.phoneSecondary : ""}
                                </td>
                            </tr>

                            {users?.socialLinks?.linkedIn && (
                                <tr>
                                    <td className={`${style.text} ps-4`}>LinkedIn</td>
                                    <td className={`${style.text} ps-4`}>
                                        <a href={users.socialLinks.linkedIn} target="_blank" rel="noreferrer">
                                            {users.socialLinks.linkedIn}
                                        </a>
                                    </td>
                                </tr>
                            )}

                            {users?.socialLinks?.github && (
                                <tr>
                                    <td className={`${style.text} ps-4`}>Github</td>
                                    <td className={`${style.text} ps-4`}>
                                        <a href={users.socialLinks.github} target="_blank" rel="noreferrer">
                                            {users.socialLinks.github}
                                        </a>
                                    </td>
                                </tr>
                            )}

                            {users?.socialLinks?.x && (
                                <tr>
                                    <td className={`${style.text} ps-4`}>X</td>
                                    <td className={`${style.text} ps-4`}>
                                        <a href={users.socialLinks.x} target="_blank" rel="noreferrer">
                                            {users.socialLinks.x}
                                        </a>
                                    </td>
                                </tr>
                            )}

                            <tr>
                                <td className={`${style.text} ps-4`}>Age</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.age ? users.age : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Role</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.role ? users.role : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Gender</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.gender ? users.gender : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Position</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.position ? users.position : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Team Name</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.teamName ? users.teamName : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Address</td>
                                <td className={`${style.text} ps-4`}>
                                    {users?.address ? users.address : "Pending"}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <p className="text-center ">Payroll Details</p>
                    <table className="table table-striped table-hover">
                        <tbody>
                            <tr>
                                <td className={`${style.text} ps-4 w-50 `}>Base Salary</td>
                                <td className={`${style.text} ps-4 w-50`}>
                                    {payrolls?.baseSalary
                                        ? Number(payrolls.baseSalary).toLocaleString('en-IN')
                                        : "Pending"}

                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Bonus</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.bonus
                                        ? Number(payrolls.bonus).toLocaleString('en-IN')
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Allowances</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.allowances
                                        ? Number(payrolls.allowances).toLocaleString('en-IN')
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Deductions</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.deductions
                                        ? Number(payrolls.deductions).toLocaleString('en-IN')
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Gross Salary</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.grossSalary
                                        ? Number(payrolls.grossSalary).toLocaleString('en-IN')
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Net Salary</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.netSalary
                                        ? Number(payrolls.netSalary).toLocaleString('en-IN')
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Created By</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.createdBy
                                        ? typeof payrolls.createdBy === "object"
                                            ? payrolls.createdBy.employeeId || "Unknown"
                                            : payrolls.createdBy
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Created At</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.createdAt
                                        ? formattedDateTime(payrolls.createdAt)
                                        : "Pending"}
                                </td>
                            </tr>
                            <tr>
                                <td className={`${style.text} ps-4`}>Last Update</td>
                                <td className={`${style.text} ps-4`}>
                                    {payrolls?.updatedAt
                                        ? formattedDateTime(payrolls.updatedAt)
                                        : "Pending"}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div >

            </div >
        </>
    );
}
